import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { HelperService } from '../utils/helper.service';
import { UserProfileService } from '../api/user-profile.service';

@Injectable()
export class CurrencyInterceptor implements HttpInterceptor {
  constructor(
    private helperService: HelperService,
    private userProfileService: UserProfileService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const interceptMethods = ['GET', 'PUT', 'POST'];
    if (interceptMethods.includes(request.method) &&
      +this.userProfileService.getCurrencyDecimalsLocalStorage() === 0 &&
      this.filteredUrl(request.url, request.method)) {
      return next.handle(request)
        .pipe(
          filter((event: HttpEvent<any>) => event instanceof HttpResponse),
          map((response: HttpResponse<any>) => {
            const modBody = this.transformValues(response.body);
            const modResponse = response.clone({ body: modBody });
            return modResponse;
          })
        );
    }
    return next.handle(request);
  }

  private filteredUrl(url: string, method: string): boolean {
    const urls = [
      'sales',
      'leases',
      'properties',
      'fee_component',
      'fee_split',
      'expense',
      'additionalfee',
      'incentive',
      'rent_review',
      'annual_rent',
      'fee_period'
    ];
    let filtered = '', splittedUrl = [];
    splittedUrl = url.slice(0, -1).split('/');
    if (splittedUrl.length > 0) {
      switch (method) {
        case 'GET':
        case 'POST':
          filtered = splittedUrl[splittedUrl.length - 1];
          const isNumberOnly = filtered.match(/[^0-9]/g);
          if (!isNumberOnly) {
            filtered = splittedUrl[splittedUrl.length - 2];
          }
          break;
        case 'PUT':
          filtered = splittedUrl[splittedUrl.length - 2];
          break;
      }
    }
    return urls.includes(filtered);
  }

  private transformValues(body: object): object {
    // Fields to be transformed
    const fields = [
      'amount',
      'transaction_amount',
      'flat_amount',
      'disbursement_allocation_amount',
      'actual_fee',
      'additional_fee',
      'smf',
      'noi_field',
      'gross_revenue_erv',
      'purchase_amount',
      'total_price',
      'conjunctional_agent_fee_amount',
      'lease_total_fee',
      'lease_total_cbre_fee',
      'lease_transaction_amount',
      'installment_billing_amount',
      'total_incentive',
      'guarentee_amount',
      'tenant_deposit_amount',
      'fee_amount',
      'trans_amount',
      'incentive_amount',
      'review_amount',
      'loan_capital',
      'asset_value',
      'annual_rent',
      'annual_outgoing',
      'annual_car_park',
      'annual_outgoing_period',
      'rent_sm'
    ];
    /*
    Our API's response could be like this:
        1. { count: 0, results: [{}, {}, ...] }
        2. { field1: '', field2: '', ...}
    */
    for (const key in body) {
      if (Array.isArray(body[key])) {
        body[key] = body[key].map((field: any) => {
          for (const keyField in field) {
            if (fields.includes(keyField)) {
              field[keyField] = this.helperService.getCurrencyFormat(+field[keyField], keyField);
            }
          }
          return field;
        });
      } else {
        if (fields.includes(key)) {
          body[key] = this.helperService.getCurrencyFormat(+body[key], key);
        }
      }
    }
    return body;
  }

}

